// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_js-datepicker_dist_datepicker_min_js-node_modules_lightgallery_lightgall-b82927"], () => (__webpack_require__("./app.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
